<template>
  <div class="page">
    <div class="consult_main">
      <div class="item" v-for="(item,index) in NewsConsultList" :key="item.Id" @click="goLink(item.Id)">
        <el-image style="width: 13.6875rem;height: 9.1875rem;" :src="resolveNewsImageUrl(item.NewsImagePath)"
          fit="cover"></el-image>

        <div class="item_right">
          <div class="NewsConsult_title">
            {{item.NewsTitle}}
          </div>

          <div class="NewsConsult_desc">
            {{item.NewsDesc}}
          </div>

          <div class="NewsConsult_Time">
            <i class="el-icon-time"></i>
            {{item.CreateTime}}
          </div>
        </div>
      </div>

      <el-pagination :hide-on-single-page="data.TotalCount < 5" :current-page="currentPage" @current-change="handleCurrentChange"
        :page-size="10" background layout="prev, pager, next" :total="data.TotalCount"
        style="margin: 1.25rem auto 0;width: 15rem;">
      </el-pagination>
    </div>
  </div>
</template>

<script>
	const newsImage = require('../../newsImage');

	export default {
		data() {
			return {
				NewsConsultList: [], //签证资讯
				data:{},
				currentPage:1
			};
		},
		created() {
			this.GetNewsConsult()
		},
		methods: {
			resolveNewsImageUrl: newsImage.resolveNewsImageUrl,
			goLink(id){
				this.$router.push('/newsdetails?id='+id )
			},
      handleCurrentChange(val){
        this.currentPage = val
        this.GetNewsConsult()
      },
			// 获取签证资讯
			GetNewsConsult() {
				this.$api.GetNewsConsult({
					PageIndex: this.currentPage,
					PageSize: 10,
				}).then(res => {
					let {
						data,
						result
					} = res.data
					console.log(res.data)
					if (result) {
						// 转换时间格式
						let TimeList = data.DataList
						TimeList = TimeList.map((item, index) => {
							const timestamp = parseInt(item.CreateTime.match(/\d+/)[0]);
							const date = new Date(timestamp);
							const formattedTime =
								`${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
							return {
								...data.DataList[index],
								CreateTime: formattedTime,
							};
						});
						this.data = data
						this.NewsConsultList = TimeList
					} else {
						this.NewsConsultList = []
					}
				})
			},
		}
	}
</script>

<style lang='less' scoped>
  .page {
    text-align: left;
    /* background-color: #fff; */
    overflow: hidden;

    &>div {
      /* overflow: hidden; */
      /* width: 75rem; */
			width: 900px;
      height: auto;
      margin: 1.25rem auto 7.5rem;
      background-color: #fff;
			padding-bottom: 1.25rem;
      .item {
        width: 90%;
				margin:  0 auto;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #eeeeee;
        padding: 1.875rem 1.25rem;
        cursor: pointer;

        .item_right {
          /* width: 60.125rem; */
					width: 565px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          &>div:nth-child(2) {
            flex: 1;
          }

          .NewsConsult_title {
            font-size: 1.25rem;
            font-weight: 600;

          }

          .NewsConsult_desc {
            font-size: 1rem;
            color: #666;
            overflow: hidden;
            white-space: normal;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            margin-top: 1.25rem;
          }

          .NewsConsult_Time {
            font-size: 0.875rem;
            color: #999;

            .el-icon-time {
              color: #999;

            }
          }
        }
      }
    }

  }

</style>



// WEBPACK FOOTER //
// src/page/news/news.vue